import { put, takeEvery } from 'redux-saga/effects';
import { apiPython as api } from '../../../service/api';
import URLs from '../../../constants/urls';
import {
  sendWelcomeEmail,
  sendWelcomeEmailFailure,
  sendWelcomeEmailSuccess
} from '../../features/SendWelcomeEmail/SendWelcomeEmailSlice';

export function* sendWelcomeEmailSaga(action) {
  try {
    const response = yield api.post(URLs.SEND_USER_EMAIL, action.payload);
    const body = response?.data;
    const sent =
      typeof body?.data === 'number'
        ? body.data
        : typeof body === 'number'
          ? body
          : null;

    if (sent !== null && sent > 0) {
      yield put(sendWelcomeEmailSuccess(`Welcome email sent (${sent} recipient(s)).`));
      return;
    }

    yield put(
      sendWelcomeEmailFailure(
        body?.message ||
          (sent === 0
            ? 'No emails were sent. Ensure the user exists with that email, welcome templates (EmailType 11/6) exist, and Azure Graph or SMTP is configured on the server.'
            : 'Failed to send welcome email')
      )
    );
  } catch (error) {
    yield put(sendWelcomeEmailFailure('Something went wrong'));
  }
}

function* watchEmailSagas() {
  yield takeEvery(sendWelcomeEmail.type, sendWelcomeEmailSaga);
}

export default watchEmailSagas;
